import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

import { IntercomUnreadCount, PermissionModal } from './types';

export const permissionModalState = atomWithReset<PermissionModal>({
  isOpen: false,
});

export const intercomUnreadCountState = atom<IntercomUnreadCount>({
  unreadCount: 0,
});
